import { Component, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Component({ 
  selector: 'button-spinner',
  template: `
    <div *ngIf="!isLoading; else exportingDataSpinner">
      <ng-content>
      </ng-content>
    </div>
    <ng-template #exportingDataSpinner>
        <div style="padding-top: 6px">
            <mat-spinner [diameter]="diameter"></mat-spinner>
        </div>
    </ng-template>
  `,
  styles: [""]
})
export class ButtonSpinnerDirective {
  isLoading: boolean = false;

  @Input()
  set inProgress(condition: boolean) {
    setTimeout(() => this.isLoading = condition, 100);
  }

  @Input() diameter: number = 35;

  // @Input() set buttonSpinner(condition: boolean) {
  //   if (!condition && !this.hasView) {
  //     this.viewContainer.createEmbeddedView(this.templateRef);
  //     this.hasView = true;
  //   } else if (condition && this.hasView) {
  //     this.viewContainer.clear();
  //     this.hasView = false;
  //   }
  // }
}